export default {"src":"/_next/static/media/tiktok.71335f2f.svg","height":24,"width":24};